// extracted by mini-css-extract-plugin
module.exports = {"category":"Category_category__1AKxG","actions":"Category_actions__3ELwl"};